import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { UploadCaseFileService } from '@secca/core/services/upload-case-file.service';
import { ICCSplitInvoiceItem } from '@secca/shared/models/ICCInvoiceSplit/i-c-c-split-invoice-item';

@Component({
  selector: 'app-file-upload',
  templateUrl: './upload-case-file.component.html',
  styleUrls: ['./upload-case-file.component.scss'],
  standalone: false,
})
export class UploadCaseFileComponent {
  @Input() splitItem: ICCSplitInvoiceItem;
  @Input() supplierInvoiceId: number;
  @Input() isApproved: boolean;

  @Output() documentChanged = new EventEmitter<{ docId: string, docName: string }>();

  @ViewChild('fileSelector') fileSelector: ElementRef;

  constructor(private fileUploadService: UploadCaseFileService) {}


  updateSplitItem(docId: string, docName: string) {
    this.documentChanged.emit({ docId, docName });
  }

  onFileSelected(event: any): void {
    const selectedFile = event.target.files[0];

    if (selectedFile) {
      const linkedCaseId = this.splitItem.caseId;
      this.fileUploadService.uploadFile(this.supplierInvoiceId, linkedCaseId, selectedFile).subscribe(
        response => {
          this.updateSplitItem(response.val, selectedFile.name);
          console.log('File uploaded successfully', this.splitItem.documentId);
        },
        error => {
          console.error('Error uploading file', error);
        }
      );
    }
  }

  onUpload(): void {
    const fileInput = this.fileSelector.nativeElement as HTMLInputElement;
    fileInput.click();
  }

  onDelete(): void {
    this.fileUploadService.deleteFile(this.supplierInvoiceId, this.splitItem.documentId).subscribe(
      response => {
        if (response == true) {
          this.updateSplitItem(null, null);
          console.log('File deleted successfully');
        }
      },
      error => {
        console.error('Error deleting file', error);
      }
    );
  }

  onDocumentIdClick() {
    this.fileUploadService.getFile(this.splitItem.documentId).subscribe(
      response => {
        const blob = new Blob([response], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        const newWindow = window.open(url, '_blank');
        console.log('File fetched successfully');
      },
        error => {
          console.error('Error fetching file', error);
        }
    );
  }

}
